<div class="page-breadcrumb second-color-text">
    <div class="row">
        <div class="col-12 align-self-center">
            <h2 class="page-title">{{pageInfo?.title | translate}}</h2>
            <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
                            <li class="breadcrumb-item" *ngIf="!last" [routerLink]="url.url" style="cursor: pointer;">{{url.title | translate}}
                            </li>
                            <li class="breadcrumb-item active" *ngIf="last">{{url.title | translate}}</li>
                        </ng-template>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>
